import { useEffect, useRef, useState } from 'react'
import { BackBtn, Loader } from '@nv/basic-components'
import { CandidateBio, CandidateLinks, CandidateProfileHeader, EventStateStatus, Skeleton } from '@nv/components'
import { useCheckVotingOpenStateChange, useGetEvent } from '@nv/hooks'
import { getEventStateStatus } from '@nv/utils'
import { useVoterUserContext } from 'libs/contexts/src/lib/VoterUserContext'
import { NominatorService } from 'libs/services/src/lib/voter/NominatorService'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import styles from './VoterCandidateProfileViewer.module.scss'

export const VoterCandidateProfileViewer = () => {
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language
  const { eventId, qid, candidateId } = useParams()
  const [candidate, setCandidate] = useState(null)
  const VoterUser = useVoterUserContext().voterUser
  const myProfile = candidate?.nominee?.id === VoterUser.id
  const [loading, setLoading] = useState(false)
  const event = useGetEvent(eventId)
  const { votingOpen } = useCheckVotingOpenStateChange({ event, closeDate: event?.closeDate })
  const hasFetchedRef = useRef(false)
  const isHeaderLoading = !event

  const getCandidacy = async () => {
    setLoading(true)
    const candidateData = await NominatorService.fetchCandidate(candidateId)
    setLoading(false)
    setCandidate(candidateData)
  }

  useEffect(() => {
    if (!candidateId) return
    if (hasFetchedRef.current) return
    hasFetchedRef.current = true

    getCandidacy()
  }, [candidateId])

  if (!candidate) return <Loader />

  return (
    <div className={styles['container']}>
      <BackBtn />
      {eventId && (
        <div className={styles['header']}>
          <div className={styles['header__details']}>
            <h1>{isHeaderLoading ? <Skeleton width={220} height={32} /> : event?.name[currentLanguage]}</h1>

            {isHeaderLoading ? (
              <Skeleton width={140} height={20} />
            ) : (
              <EventStateStatus eventStatus={getEventStateStatus(event?.state, votingOpen, event?.nominationState)} />
            )}

            <h2>
              {isHeaderLoading ? (
                <Skeleton width={320} height={24} />
              ) : (
                event?.questions?.find((position) => position.qid === qid)?.texts?.[currentLanguage] || ''
              )}
            </h2>
          </div>
        </div>
      )}

      {/* PROFILE HEADER */}
      <CandidateProfileHeader
        candidacy={candidate}
        loading={loading}
        editEnabled={false}
        showEndorse={event?.endorsementsRequired}
        endorsedByUser={candidate.endorsedByUser}
        endorseButtonEnabled={event?.nominationState === 'started' && !myProfile}
        fetchCandidacy={getCandidacy}
        profileImageUrl={candidate?.profilePhotoUrl}
        candidacyState={candidate?.nominationState}
      />

      {/* BIO */}
      <CandidateBio editEnabled={false} bio={candidate?.bio} onClick={null} loading={loading} />

      {/* LINKS */}
      <CandidateLinks links={candidate?.links} loading={loading} />
    </div>
  )
}
